/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SlideClassificationSubtype } from './SlideClassificationSubtype';

export type SlideClassificationLesionLine = {
    readonly id?: number;
    diagnosis_name: string;
    diagnosis_result: SlideClassificationLesionLine.diagnosis_result;
    wsi_lvl_prediction: number;
    readonly wsi_lvl_roi_positions?: Array<{
        center_point: Array<number>,
        radius: number,
        score?: number,
    }>;
    margin_status?: SlideClassificationLesionLine.margin_status | null;
    /**
     * X and Y coordinates of the margin rois
     */
    margin_coords?: Array<Array<number>> | null;
    readonly subtypes?: Array<SlideClassificationSubtype>;
}

export namespace SlideClassificationLesionLine {

    export enum diagnosis_result {
        POSITIVE = 'POSITIVE',
        NEGATIVE = 'NEGATIVE',
        INCONCLUSIVE = 'INCONCLUSIVE',
    }

    export enum margin_status {
        POSITIVE = 'POSITIVE',
        NEGATIVE = 'NEGATIVE',
        INCONCLUSIVE = 'INCONCLUSIVE',
    }


}
